export default __webpack_public_path__ + "static/media/DSC_0553.d5da83f8.jpg";